/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.79"
        height="18.79"
        viewBox="0 0 18.79 18.79"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.37 0a9.4 9.4 0 1 0 9.42 9.39A9.39 9.39 0 0 0 9.37 0Zm0 17.79a8.4 8.4 0 1 1 8.42-8.4 8.4 8.4 0 0 1-8.42 8.4Zm-.5-10.17h1v6.7h-1Zm.54-1.39a.84.84 0 0 0 .83-.84.83.83 0 0 0-.83-.83.84.84 0 0 0-.84.83.85.85 0 0 0 .84.84Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CircleWithUpsideDownExclamationPointIcon';

export default Icon;
